var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLive = function SvgLive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13604 18.3639C2.62132 14.8492 2.62132 9.15071 6.13604 5.63599M18.864 5.63599C22.3787 9.15071 22.3787 14.8492 18.864 18.3639M8.96447 15.5355C7.01184 13.5829 7.01184 10.417 8.96447 8.46441M16.0355 8.46441C17.9882 10.417 17.9882 13.5829 16.0355 15.5355M13.5 11.9999C13.5 12.5522 13.0523 12.9999 12.5 12.9999C11.9477 12.9999 11.5 12.5522 11.5 11.9999C11.5 11.4477 11.9477 10.9999 12.5 10.9999C13.0523 10.9999 13.5 11.4477 13.5 11.9999Z",
    stroke: "#D95858",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/live.67a15257.svg";
export { ForwardRef as ReactComponent };